import React, { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import { Blue3DText } from "../Models/Blue3DText/Blue3DText";
import { Color, Fog } from "three";
import { gui } from "../../../App";
import { Controller } from "lil-gui";

interface IProps {

}
export function EventScene(props: IProps) {
    const {gl: renderer, scene} = useThree();

    // Shadows
    useEffect(() => {
        // renderer.shadowMap.type = PCFSoftShadowMap;
        // renderer.setClearAlpha(.5);
        // renderer.setClearColor('#FFF')
    }, [renderer]);

    // Fog
    useEffect(() => {
        const color = '#59b1cf';
        scene.fog = new Fog(color, 15, 95);
        gui.children.forEach((child) => {
            if (((child as Controller).object as any)?.isFog) {
                child.destroy();
            }
        })
        gui.addColor(scene.fog, 'color')
            .name('Fog color')
            .onChange((value: Color) => {
                (document.querySelector('canvas') as HTMLCanvasElement).style.backgroundColor = `#${value.getHexString()}`;
            })
    }, [scene]);


    return (
        <>
            <Blue3DText />
            {/*<Car position={[0, 5, 0]} />*/}
        </>
    )
}
